import groq from 'groq';
import client from '@blankno/client';
import DarksideContainer from '@blankno/containers/DarksideContainer';
import { DarksideProvider } from '@blankno/Context/DarksideContext';
import '@blankno/styles/globals.css';
import { SanityDarkside } from '@blankno/types/sanityReturnTypes';

function MyApp({ Component, pageProps, darksideData }) {
  return (
    <DarksideProvider>
      <DarksideContainer data={darksideData}>
        <Component {...pageProps} />
      </DarksideContainer>
    </DarksideProvider>
  )
}


/**
 * This disables Automatic Static Optimization for the entire app,
 * but i think it's fine since we use getStaticProps() for most pages.
*/
MyApp.getInitialProps = async () => {
  const darksideData = await client.fetch<SanityDarkside[]>(
    groq`*[_type == "darkside2"] {pictures}`
    );
    
    return { darksideData: darksideData[0] };
  };

export default MyApp;
